<template>
  <div class="patient-with-operation-upload">
    <div class="header">
      <h3>Upload multiple patients (via CSV)</h3>
    </div>
    <div class="patient-upload-body">

      <div class="patient-upload-col">
        <div class="file-container" @drop.prevent="fileDropped" @dragover.prevent>
          <input @change="fileLoaded" ref="browseInput" type="file" name="myFile" accept=".csv" isRequired>
          <div v-if="!resource.file" class="file-label" @click="browseFileSystem()">
            Drag and drop CSV file here or click to browse
          </div>
          <div v-else class="file-uploaded-container" @click="browseFileSystem()">
            <span class="file-name file-label">
              <rp-sprite class="done-icon" name="done"/>
              {{resource.file.name}}
            </span>
          </div>
        </div>
        <rp-select v-if="showHospital"
          v-model="resource.hospital_id"
          placeholder="Hospital"
          :error="hospital_idError"
          @input="touch('hospital_id')"
          isRequired>
          <option v-for="hospital in hospitals" :key="hospital.id" :value="hospital.id">
            {{hospital.name}}
          </option>
        </rp-select>
        <rp-select v-if="showLocale"
          v-model="resource.locale_id"
          placeholder="Patient Language"
          :error="locale_idError"
          @input="touch('locale_id')"
          isRequired>
          <option v-for="locale in locales" :key="locale.id" :value="locale.id">
            {{locale.name}}
          </option>
        </rp-select>
        <rp-select
          v-model="resource.operation_type_id"
          placeholder="Operation Type"
          :error="operation_type_idError"
          @input="touch('operation_type_id')"
          isRequired>
          <option v-for="type in operationTypes" :key="type.id" :value="type.id">
            {{type.name}}
          </option>
        </rp-select>
      </div>

      <div class="patient-upload-col button-col">
        <a :href="templateUrl">
          <div>
            <rp-sprite class="button-icon" name="csv_icon" />
            Download Excel template
          </div>
        </a>
        <a v-if="advancedTemplateUrl" :href="advancedTemplateUrl">
          <div>
            <rp-sprite class="button-icon" name="csv_icon" />
            Download Advanced Excel template
          </div>
        </a>
        <a :href="learnUrl" target="_blank">
          <div>
            <rp-sprite class="button-icon" name="learn_icon" />
            See how this works <span v-if="advancedLearnUrl">(normal template)</span>
          </div>
        </a>
        <a v-if="advancedLearnUrl" :href="advancedLearnUrl" target="_blank">
          <div>
            <rp-sprite class="button-icon" name="learn_icon" />
            See how this works (advanced template)
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
  import form from '../../../mixins/form'
  import Sprite from '../../../components/ui/Sprite'
  import Button from '../../../components/ui/inputs/Button'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import {errorMessages} from '../../../api/error_messages'
  import {required, requiredIf} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'

  export default {
    name: 'PatientWithOperationUpload',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-sprite': Sprite,
      'rp-select': Select,
    },

    computed: {
      ...errorMessages(['locale_id', 'hospital_id', 'operation_type_id']),
    },

    props: {
      hospitals: Array,
      locales: Array,
      operationTypes: Array,
      templateUrl: String,
      advancedTemplateUrl: String,
      learnUrl: String,
      advancedLearnUrl: String,
      showHospital: Boolean,
      showLocale: Boolean,
    },

    methods: {
      fileLoaded(event) {
        this.setActiveFile(event.target.files[0])
      },

      fileDropped(event) {
        this.setActiveFile(event.dataTransfer.files[0])
      },

      setActiveFile(file) {
        if (file.type.includes("csv") || file.name.toLowerCase().endsWith('.csv')) {
          this.resource.file = file
        }
      },

      browseFileSystem() {
        this.$refs.browseInput.value = null
        this.$refs.browseInput.click()
      },
    },

    validations: {
      resource: {
        file: {required},
        hospital_id: {required: requiredIf(function(n) {
          return this.showHospital
        })},
        locale_id: {required: requiredIf(function(n) {
          return this.showLocale
        })},
        operation_type_id: {required},
      }
    },
  }
</script>


<style lang="sass" scoped>
  @import '../../../styles/base/variables'

  .patient-with-operation-upload
    background: $color-panel-bg
    border-radius: 20px
    max-width: 1200px
    h3
      text-transform: none

    .header
      color: $color-text
      > h3
        margin-bottom: 0

    .patient-upload-body
      display: flex

      .patient-upload-col
        flex: 1
        display: flex
        flex-direction: column

        .file-container
          border: 1px solid grey;
          border-radius: 5px
          display: flex
          justify-content: center
          align-items: center
          width: 100%
          margin: 15px 0 5px 0
          min-height: 40px

          input
            display: none

          .file-label
            font-size: 1.3rem
            cursor: pointer

            .done-icon
              width: 24px
              height: 24px
              fill: #8BC34A
              margin: -6px 0 -6px 0

      .button-col
        gap: 20px
        padding: 15px 15px 15px 25px
        font-size: larger

        .button-icon
          width: 30px
          height: 30px
          stroke: $color-text
          stroke-width: 4px
          fill: transparent
          vertical-align: middle
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/PatientWithOperationUpload.vue